import { Component, NgZone, OnDestroy } from '@angular/core';
import { CopyService } from '../../services/copy-and-paste/copy.service';
import { PasteService } from '../../services/copy-and-paste/paste.service';
import { ButtonState, ToolButton, TooltipState } from './tool-button';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss', 'tool-button.scss'],
    standalone: false
})
export class ToolbarComponent implements OnDestroy {
  copyButton: ToolButton;
  pasteButton: ToolButton;

  constructor(private copyService: CopyService, private pasteService: PasteService, ngZone: NgZone) {
    this.copyButton = new ToolButton(
      () => this.copyService.doCopy(),
      new ButtonState(false, copyService.copyValidStateChange$, ngZone),
      new TooltipState(copyService.copyAction$, ngZone)
    );
    this.pasteButton = new ToolButton(
      () => this.pasteService.doPaste(),
      new ButtonState(false, pasteService.pasteValidStateChange$, ngZone),
      new TooltipState(pasteService.pasteAction$, ngZone)
    );
  }

  ngOnDestroy() {
    this.copyButton.unsubscribe();
    this.pasteButton.unsubscribe();
  }
}
